import script from "./BookingCreate.vue?vue&type=script&lang=ts&setup=true"
export * from "./BookingCreate.vue?vue&type=script&lang=ts&setup=true"

import "./BookingCreate.vue?vue&type=style&index=0&id=3d585c52&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d585c52"]])

export default __exports__